var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "websliderHp";

var DEFAULTS = {
	minScreenWidth: 320,
	data: [],
	slideContentFormatter: function (data, i) {
		var result = '';
		var checkIsModalLink = "https://www.youtube.com/";
		if (data[i].title && data[i].title != '') {
			result += '<h1 class="landing__headline">' + data[i].title + '</h1>';
		}
		if (data[i].description && data[i].description != '') {
			result += '<p class="landing__text">' + data[i].description + '</p>';
		}
		if ((data[i].link1 && data[i].link1 != '') || (data[i].link2 && data[i].link2 != '')) {
			result += '<div class="buttons">';
			if (data[i].link1 && data[i].link1 != '') {
				if (data[i].link1.includes(checkIsModalLink)) {
					result += '<a class="btn btn-primary btn-lg js_show-modal-video gtm-career-cta" data-url="' + data[i].link1 + '" data-toggle="modal" data-target="#video">' + data[i].link1Name + '</a>';
				} else {
					result += '<a class="btn btn-primary btn-lg gtm-career-cta" href="' + data[i].link1 + '" data-web-component>' + data[i].link1Name + '</a>';
				}
			}
			if (data[i].link2 && data[i].link2 != '') {
				if (data[i].link2.includes(checkIsModalLink)) {
					result += '<a class="btn btn-default btn-lg js_show-modal-video gtm-career-cta" data-url="' + data[i].link2 + '"  data-toggle="modal" data-target="#video">' + data[i].link2Name + '</a>';
				} else {
					result += '<a class="btn btn-default btn-lg gtm-career-cta" href="' + data[i].link2 + '" data-web-component>' + data[i].link2Name + '</a>';
				}
			}
			result += '</div>';
		}
		return result;
	},
	controlArrows: false,
	controlPoints: true,
	slideTime: 8000
};

// The actual plugin constructor
function WebSliderHp(element, options) {
	this.element = element;

	this.options = $.extend(true, {}, DEFAULTS, options);
	this._wWidth = window.innerWidth;

	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;

	this._changeTimer = null;

	this.initialise();

}

/**
 * init
 */
WebSliderHp.prototype.initialise = function () {
	if (this._wWidth < this.options.minScreenWidth) {
		$(this.element).empty().hide();
		return false;
	}
	this.actualSlide = 0;
	$(this.element).show();

	if (this.options.data.length === 1) {
		this.getRenderSlide(this.actualSlide);
	}

	if (this.options.data.length > 1) {
		this.renderControls();
		this.rotate(this.actualSlide, 'next');
		this.startRotation();
	}
};


WebSliderHp.prototype.initModal = function (currentSlide) {

}

/**
 * read data and build slides list
 */
WebSliderHp.prototype.getRenderSlide = function (i) {
	const self = this;
	if (this.options.data[this.actualSlide].motive) {
		$('.career-landing-img').css('background-image', 'url(' + this.options.data[this.actualSlide].motive + ')');
	}
	var htmlResult = this.options.slideContentFormatter(this.options.data, i);
	$(this.element).animate({opacity: 0}, 0);
	$(this.element).html(htmlResult);
	$(this.element).animate({opacity: 1}, 300);
	if (this.options.data.length > 1) {
		this.updateControlPoints(this.actualSlide);
	}
	this.initGTM();
};

/**
 * render controls
 */
WebSliderHp.prototype.renderControls = function() {
	this.controlArrows = (this.options.controlArrows) ? this.renderControlArrows() : null;
	this.controlPoints = (this.options.controlPoints) ? this.renderControlPoints() : null;

	if (this.controlArrows) {
		$(this.element).append(this.controlArrows);
		this.bindControlArrows();
	}

	if (this.controlPoints) {
		$(this.element).after(this.controlPoints);
		this.bindControlPoints();
		this.updateControlPoints(this.actualSlide);
	}
};

/**
 * renders control arrows
 */
WebSliderHp.prototype.renderControlArrows = function() {
	var str = '';
	str += '<span class="glyphicon glyphicon-arrow-left3 slider-arrow prev"></span>';
	str += '<span class="glyphicon glyphicon-arrow-right3 slider-arrow next"></span>';
	return str;
};

/**
 * bind action to control arrows
 */
WebSliderHp.prototype.bindControlArrows = function() {
	var self = this;
	$('span.slider-arrow', $(this.element)).bind('click', function() {
		clearTimeout(this._changeTimer);
		if ($(this).hasClass('prev')) {
			self.rotate(self.actualSlide, 'prev');
		}

		if ($(this).hasClass('next')) {
			self.rotate(self.actualSlide, 'next');
		}
	});
};

/**
 * renders control points
 */
WebSliderHp.prototype.renderControlPoints = function() {
	var str = '<ul class="control-points">';
	for (var i = 0; i < this.options.data.length; i++) {
		str += '<li data-index="'+ i +'"><span>' + i + '</span></li>';
	}
	str += '</ul>';
	return str;
};

/**
 * bind action to control points
 */
WebSliderHp.prototype.bindControlPoints = function() {
	var self = this;
	clearTimeout(this._changeTimer);

	$('.control-points>li', $(this.element.parentElement)).bind('click', function(e) {
		self.actualSlide = $(this).data('index');
		self.rotate(self.actualSlide, 'next');
		self.startRotation();
	});
};

/**
 * sets the right controlPoint active
 */
WebSliderHp.prototype.updateControlPoints = function(index) {
	if (this.options.controlPoints) {
		$('.control-points li', $(this.element.parentElement)).removeClass('active');
		$('.control-points li:eq(' + index + ')', $(this.element.parentElement)).addClass('active');
	}
};


/**
 *
 */
WebSliderHp.prototype.rotate = function (from, direction) {
	var newSlide = this.actualSlide;
	clearTimeout(this._changeTimer);
	if (direction == "prev") {
		newSlide--;
		newSlide = (newSlide < 0) ? this.options.data.length - 1 : newSlide;
	}

	if (direction == "next") {
		newSlide++;
		newSlide = (newSlide >= this.options.data.length) ? 0 : newSlide;
	}

	this.changeSlide(this.actualSlide, newSlide);


};

/**
 *
 * @param from
 * @param to
 */
WebSliderHp.prototype.changeSlide = function (from, to) {
	if (from == to) {
		return false;
	}

	this.getRenderSlide(this.actualSlide);

	this.actualSlide = to;
	this.startRotation();

	$('.js_show-modal-video').on('click', function(e) {
		e.preventDefault();
		$('#video .embed-responsive-item').attr('src', $(this).attr('data-url'));
	});
};


/**
 * start
 */
WebSliderHp.prototype.startRotation = function () {
	var self = this;
	clearTimeout(this._changeTimer);
	this._changeTimer = setTimeout(function () {
		self.rotate(self.actualSlide, 'next');
	}, self.options.slideTime);


};

WebSliderHp.prototype.initGTM = function () {
	$('.gtm-career-cta').on('click', function(e) {
		dataLayer.push({
			'event': 'fgWebAnalytics',
			'fgVarCat': 'Interakce se stránkou',
			'fgVarAct': 'Proklik tlačítka ' + this.innerHTML,
			'fgVarLbl': window.location.href
		});
	});
};

/**
 * decide, which methods will be "public"
 */
var API = {
	//action: WebSliderHp.prototype.action
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new WebSliderHp(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-career/src/js/web/jquery.webslider-hp.js